import { ModalPromptComponent } from './modal-prompt/modal-prompt.component';

export const modalCompositeComponents = [
  ModalPromptComponent
];
